import {ChangeEvent, useState} from 'react';
import {useSelector} from 'react-redux';
import {useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {RootState} from '../../../../../../../store/redux';
import CustomBadge from '../../../../../../../components/mazraeKit/customBadge';
import CustomMultiCheckbox from '../../../../../../../components/mazraeKit/customMultiCheckbox';
import useGetOptionalAttributes from '../../../../../../../services/hookService/getOptionalAttributes/useGetOptionalAttributes';
import FloatingOnlySelectBottomSheet from '../../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {FromikType} from '../../../../types';

interface IDropBottomSheetProps {
  data: Array<{guid: string; title: string}>;
  name: string;
  placeholder?: string;
  onChange: (guid: string) => void;
  value?: string;
}
interface IProps {
  guid: string;
  title: string;
}

function MultiSelectDropBottomSheet({
  data,
  name,
  placeholder,
  onChange,
  value,
}: IDropBottomSheetProps) {
  const {values} = useFormikContext<FromikType>();

  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const {attributesData} = useGetOptionalAttributes(state?.input_group?.type);

  const [openBottomSheet, setOpenBottomSheet] = useState<boolean>(false);

  const handleRemove = (selectedGuid: string) => {
    if (values.attributes !== undefined) {
      onChange(
        values.attributes
          ?.toString()
          .split(',')
          ?.filter(elem => elem !== selectedGuid)
          .toString(),
      );
    }
  };

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>, item: IProps) => {
    if (e.target.checked) {
      if (values.attributes === undefined) {
        onChange(item.guid);
      } else {
        onChange([values.attributes, item.guid].toString());
      }
    } else {
      handleRemove(item.guid);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <FloatingOnlySelectBottomSheet
        Placeholder={placeholder}
        name={name}
        wrapperClass="border-gray-700"
        onClick={() => {
          setOpenBottomSheet(true);
        }}
        value={value}
      />

      <div className="flex gap-2 mt-3 flex-wrap">
        {attributesData &&
          attributesData?.length > 0 &&
          attributesData
            ?.filter(item =>
              values.attributes?.toString().split(',')?.includes(item.guid),
            )
            .map((elem, index) => (
              <CustomBadge
                key={elem.guid ?? index}
                title={elem.attribute}
                onRemoveItem={() => handleRemove(elem.guid)}
              />
            ))}
      </div>
      <BottomSheet
        onDismiss={() => setOpenBottomSheet(false)}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col gap-4 p-4">
          {data?.map((item, index) => (
            <CustomMultiCheckbox
              key={item.guid ?? index}
              title={item.title}
              id={item.guid.toString()}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                onChangeHandler(e, item)
              }
              value={item.guid}
              defaultChecked={
                values.attributes
                  ?.toString()
                  .split(',')
                  .find(selectedItem => selectedItem === String(item.guid))
                  ? true
                  : false
              }
            />
          ))}
        </div>
      </BottomSheet>
    </div>
  );
}

export default MultiSelectDropBottomSheet;
